import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface MasterDetailState {
  selectedRow: any | null;
  sourceGridId: string | null;
  targetPanelId: string | null; // Legacy: single panel ID
  targetPanelIds: string[];     // Multi-panel support: array of panel IDs
  forceOpen?: boolean;
  arrayPath?: string;
  rowIndex?: number;
}

@Injectable({
  providedIn: 'root'
})
export class MasterDetailService {
  private selectedRowSubject = new BehaviorSubject<MasterDetailState>({
    selectedRow: null,
    sourceGridId: null,
    targetPanelId: null,
    targetPanelIds: []
  });

  public selectedRow$: Observable<MasterDetailState> = 
    this.selectedRowSubject.asObservable();

  /**
   * Atualiza a linha selecionada
   * @param gridId - ID da grid que emitiu o evento
   * @param rowData - Dados da linha selecionada
   * @param targetPanelId - ID do painel de destino (opcional, legacy single panel)
   * @param forceOpen - Forçar abertura do painel (default: false)
   * @param arrayPath - Path do array da grid (para suportar grids aninhadas)
   * @param rowIndex - Índice da linha no array (0-based) - evita necessidade de buscar por JSON.stringify
   * @param targetPanelIds - IDs dos painéis de destino (multi-panel support)
   */
  setSelectedRow(gridId: string, rowData: any, targetPanelId?: string, forceOpen: boolean = false, arrayPath?: string, rowIndex?: number, targetPanelIds?: string[]): void {
    // Determinar array de panel IDs: priorizar targetPanelIds, senão usar targetPanelId como array
    const panelIds = targetPanelIds || (targetPanelId ? [targetPanelId] : []);
    
    this.selectedRowSubject.next({
      selectedRow: rowData,
      sourceGridId: gridId,
      targetPanelId: targetPanelId || null, // Manter para backward compatibility
      targetPanelIds: panelIds,
      forceOpen: forceOpen,
      arrayPath: arrayPath || '',
      rowIndex: rowIndex
    });
  }

  /**
   * Abre o painel Master-Detail forçadamente
   */
  openPanel(gridId: string, rowData: any, targetPanelId?: string, targetPanelIds?: string[]): void {
    this.setSelectedRow(gridId, rowData, targetPanelId, true, undefined, undefined, targetPanelIds);
  }

  /**
   * Limpa a seleção
   */
  clearSelection(): void {
    this.selectedRowSubject.next({
      selectedRow: null,
      sourceGridId: null,
      targetPanelId: null,
      targetPanelIds: []
    });
  }

  /**
   * Obtém o estado atual
   */
  getCurrentState(): MasterDetailState {
    return this.selectedRowSubject.value;
  }
}


